import { Component } from 'react';
import { logError } from '../lib/logger.js';

/**
 * Vangt render-fouten in de paginaboom (React laat die niet via window.onerror
 * lopen). Logt de fout met componentStack en toont een nette fallback i.p.v.
 * een wit scherm. Staat rond <Routes> in App.jsx.
 */
export default class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    logError(error, { source: 'react', componentStack: errorInfo?.componentStack });
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="max-w-xl mx-auto mt-12 rounded-lg border border-red-200 bg-red-50 p-6 text-center">
        <h2 className="text-lg font-bold text-red-800">Er ging iets mis</h2>
        <p className="mt-2 text-sm text-red-700">
          Dit scherm kon niet worden geladen. De fout is opgeslagen onder Beheer → Logboek.
          Probeer de pagina te herladen.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="mt-4 rounded-md px-4 py-2 text-sm font-medium text-white"
          style={{ backgroundColor: '#1e3a5f' }}
        >
          Pagina herladen
        </button>
      </div>
    );
  }
}
